/* ─── MEGAMENU JS — megamenu.js ──────────────────────────────────────────── */

(function () {
  'use strict';

  const header     = document.getElementById('mm-header');
  const panelWrap  = document.getElementById('mm-panel-wrap');
  const backdrop   = document.getElementById('mm-backdrop');
  const pillsRow   = document.getElementById('mm-pills-row');

  if (!header || !panelWrap) return;

  const navItems = header.querySelectorAll('.mm-nav-item[data-menu]');
  let activeItem = null;
  let closeTimer = null;

  // ── Show a panel ────────────────────────────────────────────────────────────
  function openMenu(item) {
    clearTimeout(closeTimer);
    if (activeItem === item) return;

    // Deactivate previous
    if (activeItem) {
      activeItem.classList.remove('is-open');
    }

    const key = item.dataset.menu;
    const panel = panelWrap.querySelector(`.mm-panel[data-panel="${key}"]`);
    if (!panel) return;

    // Hide all panels, show target
    panelWrap.querySelectorAll('.mm-panel').forEach(p => p.classList.remove('is-active'));
    panel.classList.add('is-active');

    activeItem = item;
    activeItem.classList.add('is-open');
    panelWrap.classList.add('is-open');
    if (backdrop) backdrop.classList.add('is-active');
  }

  // ── Hide all ────────────────────────────────────────────────────────────────
  function closeMenu() {
    if (activeItem) {
      activeItem.classList.remove('is-open');
      activeItem = null;
    }
    panelWrap.classList.remove('is-open');
    if (backdrop) backdrop.classList.remove('is-active');
  }

  function scheduleClose() {
    closeTimer = setTimeout(closeMenu, 120);
  }

  function cancelClose() {
    clearTimeout(closeTimer);
  }

  // ── Nav item events ─────────────────────────────────────────────────────────
  navItems.forEach(item => {
    item.addEventListener('mouseenter', () => openMenu(item));
    item.addEventListener('mouseleave', scheduleClose);
  });

  // ── Panel events ────────────────────────────────────────────────────────────
  panelWrap.addEventListener('mouseenter', cancelClose);
  panelWrap.addEventListener('mouseleave', scheduleClose);

  // ── Backdrop / outside click ────────────────────────────────────────────────
  if (backdrop) {
    backdrop.addEventListener('click', closeMenu);
  }
  document.addEventListener('click', e => {
    if (header && !header.contains(e.target)) closeMenu();
  });

  // ── Escape key ──────────────────────────────────────────────────────────────
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') closeMenu();
  });

  // ── Pills drag-to-scroll ────────────────────────────────────────────────────
  if (pillsRow) {
    let isDragging  = false;
    let hasDragged  = false;
    let startX      = 0;
    let scrollStart = 0;

    pillsRow.addEventListener('mousedown', e => {
      isDragging  = true;
      hasDragged  = false;
      startX      = e.pageX - pillsRow.offsetLeft;
      scrollStart = pillsRow.scrollLeft;
      pillsRow.classList.add('is-dragging');
    });

    document.addEventListener('mouseup', () => {
      isDragging = false;
      pillsRow.classList.remove('is-dragging');
    });

    document.addEventListener('mousemove', e => {
      if (!isDragging) return;
      e.preventDefault();
      const x    = e.pageX - pillsRow.offsetLeft;
      const walk = (x - startX) * 1.3;
      if (Math.abs(walk) > 4) hasDragged = true;
      pillsRow.scrollLeft = scrollStart - walk;
    });

    // Block click-through after a drag so links don't fire
    pillsRow.addEventListener('click', e => {
      if (hasDragged) e.preventDefault();
    }, true);
  }

})();
